module.exports = __webpack_public_path__ + "media/images/user-placeholder-522b20f3.svg";